"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
require("./infoModal.scss");
const SuccessfullyModal = (props) => {
    const { title, description, className, open = false, cancelable, icon = false, closeIcon = false, submit } = props;
    const submitLocal = () => {
        cancelable();
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(core_1.Dialog, { open: open, onClose: () => { submitLocal(); }, fullWidth: true, maxWidth: 'sm', className: `info-modal ${className ? className : ''}` },
            closeIcon && react_1.default.createElement(core_1.IconButton, { "aria-label": "close", className: 'close-btn', onClick: () => { submitLocal(); } },
                react_1.default.createElement(Close_1.default, { className: 'modal-close-icon' })),
            react_1.default.createElement("div", { className: "modal-container text-left" },
                icon && react_1.default.createElement("div", { className: 'checked-icon' }),
                title && react_1.default.createElement("h4", { className: "modal-title" }, title),
                description && react_1.default.createElement("p", { className: "c-m-description" }, description),
                react_1.default.createElement("div", { className: "action-group" },
                    react_1.default.createElement(core_1.Button, { disableRipple: true, onClick: () => { submitLocal(); }, variant: "outlined", className: "v2-btn v2-btn-tertiary" }, (submit === null || submit === void 0 ? void 0 : submit.buttonTitle) ? submit === null || submit === void 0 ? void 0 : submit.buttonTitle : 'Ok, got it'))))));
};
exports.default = SuccessfullyModal;
